(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefits-zigzag"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function initReveal(root) {
      var els = root.querySelectorAll('[data-bz-reveal]');
      if (reduceMotion || !('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
      );
      els.forEach(function (el) { io.observe(el); });
    }

    function initVideos(root) {
      root.querySelectorAll('[data-bz-video]').forEach(function (video) {
        var loaded = false;

        function load() {
          if (loaded) return;
          loaded = true;
          video.querySelectorAll('source[data-src]').forEach(function (s) {
            s.src = s.getAttribute('data-src');
          });
          video.muted = true;
          video.load();
        }

        function play() {
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }

        video.addEventListener('playing', function () { video.classList.add('is-playing'); });

        if (!('IntersectionObserver' in window)) {
          load();
          play();
          return;
        }

        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                load();
                if (!reduceMotion) play();
              } else if (loaded) {
                video.pause();
              }
            });
          },
          { rootMargin: '150px', threshold: 0.2 }
        ).observe(video);
      });
    }

    function init(root) {
      if (root.__bzReady) return;
      root.__bzReady = true;
      initReveal(root);
      initVideos(root);
    }

    function initAll() {
      document.querySelectorAll('[data-bz]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-bz]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer-custom"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__cdcLoaded) return;
    window.__cdcLoaded = true;

    var origFetch = window.fetch ? window.fetch.bind(window) : null;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var instance = null;
    var globalsBound = false;
    var COUPON_KEY = 'cdc_coupon';
    var OFFER_KEY = 'cdc_offer';
    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function storageSet(key, value) {
      try {
        if (value === null) window.localStorage.removeItem(key);
        else window.localStorage.setItem(key, value);
      } catch (e) {}
    }

    class CartDrawerCustom extends HTMLElement {
      connectedCallback() {
        if (this.__ready) return;
        this.__ready = true;
        instance = this;
        this.sectionId = this.getAttribute('data-section-id');
        this.panel = this.querySelector('[data-cdc-panel]');
        this.content = this.querySelector('[data-cdc-content]');
        this.lastPct = parseFloat(this.getAttribute('data-pct')) || 0;
        this.recsCache = {};
        this.reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        var designMode = window.Shopify && window.Shopify.designMode;
        if (!designMode && this.parentElement !== document.body) {
          document.body.appendChild(this);
        }

        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.addEventListener('submit', this.onSubmit.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));

        this.afterRender(false);
        bindGlobals();
      }

      /* ---------- Abrir / cerrar ---------- */
      open(trigger) {
        if (this.classList.contains('is-open')) return;
        this.returnFocus = trigger || document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('cdc-lock');
        var self = this;
        setTimeout(function () {
          var closeBtn = self.querySelector('.cdc__close');
          if (closeBtn) closeBtn.focus();
        }, 60);
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.documentElement.classList.remove('cdc-lock');
        var target = this.returnFocus;
        if (target && typeof target.focus === 'function' && document.contains(target)) target.focus();
        this.returnFocus = null;
      }

      /* ---------- Eventos del drawer ---------- */
      onKeydown(e) {
        if (!this.classList.contains('is-open')) return;
        if (e.key === 'Escape') {
          e.stopPropagation();
          this.close();
          return;
        }
        if (e.key !== 'Tab') return;
        var nodes = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), function (el) {
          return el.offsetParent !== null || el === document.activeElement;
        });
        if (!nodes.length) {
          e.preventDefault();
          this.panel.focus();
          return;
        }
        var first = nodes[0];
        var last = nodes[nodes.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      onClick(e) {
        var t = e.target;
        if (t.closest('[data-cdc-close]')) {
          this.close();
          return;
        }
        var qtyBtn = t.closest('[data-cdc-qty]');
        if (qtyBtn) {
          var line = qtyBtn.closest('[data-cdc-item]');
          this.changeQty(line, parseInt(line.getAttribute('data-qty'), 10) + parseInt(qtyBtn.getAttribute('data-cdc-qty'), 10));
          return;
        }
        var removeBtn = t.closest('[data-cdc-remove]');
        if (removeBtn) {
          this.changeQty(removeBtn.closest('[data-cdc-item]'), 0);
          return;
        }
        if (t.closest('[data-cdc-add-one]')) {
          var first = this.querySelector('[data-cdc-item]');
          if (first) this.changeQty(first, parseInt(first.getAttribute('data-qty'), 10) + 1);
          return;
        }
        var addBtn = t.closest('[data-cdc-add]');
        if (addBtn) {
          this.addFromCard(addBtn);
          return;
        }
        if (t.closest('[data-cdc-coupon-toggle]')) {
          var form = this.querySelector('[data-cdc-coupon-form]');
          var toggle = this.querySelector('[data-cdc-coupon-toggle]');
          var show = form.hidden;
          form.hidden = !show;
          toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
          if (show) form.querySelector('input').focus();
          return;
        }
        if (t.closest('[data-cdc-coupon-remove]')) {
          storageSet(COUPON_KEY, null);
          this.hydrateCoupon();
          return;
        }
        if (t.closest('[data-cdc-checkout]')) {
          var code = this.offer ? this.offer.code : storageGet(COUPON_KEY);
          window.location.href = code
            ? root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'checkout')
            : root + 'checkout';
        }
      }

      onChange(e) {
        var select = e.target.closest('[data-cdc-rec-select]');
        if (select) {
          var card = select.closest('[data-cdc-rec]');
          var btn = card.querySelector('[data-cdc-add]');
          var opt = select.options[select.selectedIndex];
          btn.setAttribute('data-variant', select.value);
          btn.disabled = opt.getAttribute('data-available') !== 'true';
        }
      }

      onSubmit(e) {
        var form = e.target.closest('[data-cdc-coupon-form]');
        if (!form) return;
        e.preventDefault();
        var code = form.querySelector('input').value.trim();
        if (!code) return;
        storageSet(COUPON_KEY, code);
        form.querySelector('input').value = '';
        this.hydrateCoupon();
      }

      /* ---------- Carrito ---------- */
      sectionsParam() {
        return this.sectionId + ',cart-icon-bubble';
      }

      request(url, options) {
        return origFetch(url, options).then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, status: res.status, data: data };
          });
        });
      }

      applySections(sections) {
        if (!sections) return;
        if (sections[this.sectionId]) this.renderHtml(sections[this.sectionId]);
        if (sections['cart-icon-bubble']) this.renderBubble(sections['cart-icon-bubble']);
      }

      changeQty(line, quantity) {
        if (!line || quantity < 0) return Promise.resolve();
        var key = line.getAttribute('data-key');
        var max = parseInt(line.getAttribute('data-max'), 10) || 0;
        var self = this;
        if (max > 0 && quantity > max) {
          this.lineError(line, 'Solo hay ' + max + ' unidades disponibles.');
          return Promise.resolve();
        }
        this.setLineLoading(line, true);
        return this.request(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity: quantity, sections: this.sectionsParam(), sections_url: window.location.pathname })
        })
          .then(function (res) {
            if (!res.ok) {
              self.setLineLoading(line, false);
              self.lineError(line, res.data.description || res.data.message || 'No se pudo actualizar la cantidad.');
              return;
            }
            self.applySections(res.data.sections);
            if (quantity > 0) {
              var updated = null;
              (res.data.items || []).forEach(function (it) { if (it.key === key) updated = it; });
              if (updated && updated.quantity < quantity) {
                var newLine = self.querySelector('[data-cdc-item][data-key="' + key + '"]');
                if (newLine) self.lineError(newLine, 'Solo hay ' + updated.quantity + ' unidades disponibles.');
              }
            }
          })
          .catch(function () {
            self.setLineLoading(line, false);
            self.lineError(line, 'No se pudo actualizar. Inténtalo de nuevo.');
          });
      }

      setLineLoading(line, on) {
        line.classList.toggle('is-loading', on);
        line.querySelectorAll('button').forEach(function (b) { b.disabled = on ? true : b.disabled; });
        line.setAttribute('aria-busy', on ? 'true' : 'false');
      }

      lineError(line, message) {
        var box = line.querySelector('[data-cdc-line-error]');
        if (!box) return;
        box.textContent = message;
        box.hidden = false;
        clearTimeout(box.__t);
        box.__t = setTimeout(function () { box.hidden = true; }, 5000);
      }

      toast(message) {
        var box = this.querySelector('[data-cdc-toast]');
        if (!box) return;
        box.textContent = message;
        box.hidden = false;
        clearTimeout(this.__toastT);
        this.__toastT = setTimeout(function () { box.hidden = true; }, 5000);
      }

      /* Agrega con un FormData (formularios del tema) */
      addFromForm(form, submitter) {
        var self = this;
        var data = new FormData(form);
        data.append('sections', this.sectionsParam());
        data.append('sections_url', window.location.pathname);
        if (submitter) submitter.disabled = true;
        return this.request(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: data
        })
          .then(function (res) {
            if (!res.ok) {
              self.open(submitter);
              self.toast(res.data.description || res.data.message || 'No se pudo agregar el producto.');
              return;
            }
            self.applySections(res.data.sections);
            self.open(submitter);
          })
          .catch(function () {
            form.__cdcBypass = true;
            form.submit();
          })
          .finally(function () {
            if (submitter) submitter.disabled = false;
          });
      }

      /* Agrega una variante (cross-sell) sin cerrar el carrito */
      addFromCard(btn) {
        var self = this;
        var variant = btn.getAttribute('data-variant');
        if (!variant) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        function reset() {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          btn.removeAttribute('aria-busy');
        }
        this.request(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(variant), quantity: 1 }], sections: this.sectionsParam(), sections_url: window.location.pathname })
        })
          .then(function (res) {
            if (!res.ok) {
              reset();
              self.toast(res.data.description || res.data.message || 'No se pudo agregar el producto.');
              return;
            }
            self.applySections(res.data.sections);
          })
          .catch(function () {
            reset();
            self.toast('No se pudo agregar el producto.');
          });
      }

      /* Re-render por cambios externos (apps u otras secciones) */
      refresh() {
        var self = this;
        var url = root + '?sections=' + encodeURIComponent(this.sectionsParam()) + '&_=' + Date.now();
        return origFetch(url, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (sections) { self.applySections(sections); })
          .catch(function () {});
      }

      /* ---------- Render ---------- */
      renderHtml(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector('cart-drawer-custom');
        var nextContent = next && next.querySelector('[data-cdc-content]');
        if (!nextContent) return;
        var pctFrom = this.lastPct;
        this.content.innerHTML = nextContent.innerHTML;
        this.setAttribute('data-count', next.getAttribute('data-count'));
        this.setAttribute('data-total', next.getAttribute('data-total'));
        this.setAttribute('data-item-count', next.getAttribute('data-item-count'));
        this.setAttribute('data-cart-key', next.getAttribute('data-cart-key'));
        this.setAttribute('data-total-cents', next.getAttribute('data-total-cents'));
        this.setAttribute('data-pct', next.getAttribute('data-pct'));
        this.afterRender(true, pctFrom, next.getAttribute('data-total'));
      }

      renderBubble(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var wrapper = doc.querySelector('.shopify-section') || doc.body;
        var target = document.querySelector('#cart-icon-bubble');
        if (target && wrapper) target.innerHTML = wrapper.innerHTML;
      }

      afterRender(announce, pctFrom, total) {
        var bar = this.querySelector('[data-cdc-bar]');
        var pct = parseFloat(this.getAttribute('data-pct')) || 0;
        if (bar) {
          if (announce && !this.reduceMotion && pctFrom !== undefined) {
            bar.style.transition = 'none';
            bar.style.width = pctFrom + '%';
            void bar.offsetWidth;
            bar.style.transition = '';
            requestAnimationFrame(function () { bar.style.width = pct + '%'; });
          } else {
            bar.style.width = pct + '%';
          }
        }
        this.lastPct = pct;
        this.applyOffer();
        this.hydrateCoupon();
        this.loadRecs();
        if (announce && total) {
          var live = this.querySelector('[data-cdc-live]');
          if (live) {
            live.textContent = '';
            setTimeout(function () { live.textContent = 'Carrito actualizado. Total: ' + total; }, 50);
          }
        }
      }

      /* Ofertas de la página de producto (cantidad + precio especial): el precio de oferta se
         cobra con un código de descuento que Shopify aplica en el checkout. Aquí solo se
         muestra el descuento para que el total coincida con lo que vio el cliente. */
      applyOffer() {
        this.offer = null;
        var raw = storageGet(OFFER_KEY);
        var offer = null;
        try { offer = raw ? JSON.parse(raw) : null; } catch (e) { offer = null; }
        var items = this.querySelectorAll('[data-cdc-item]');
        var valid = offer && offer.code && items.length === 1 &&
          items[0].getAttribute('data-variant') === String(offer.variant) &&
          parseInt(items[0].getAttribute('data-qty'), 10) === offer.qty;
        if (!valid) {
          if (offer) storageSet(OFFER_KEY, null);
          return;
        }
        var base = parseInt(this.getAttribute('data-total-cents'), 10) || 0;
        var discount = base - offer.price;
        if (discount <= 0) return;
        this.offer = offer;
        var fmt = function (cents) { return '$' + Math.round(cents / 100).toLocaleString('es-CO'); };
        var summary = this.querySelector('.cdc__summary');
        if (summary && !summary.querySelector('.cdc__row--offer')) {
          var totalRow = summary.querySelector('.cdc__row--total');
          var row = document.createElement('div');
          row.className = 'cdc__row cdc__row--discount cdc__row--offer';
          row.innerHTML = '<dt>Oferta (se aplica en el pago)</dt><dd>-' + fmt(discount) + '</dd>';
          if (totalRow) summary.insertBefore(row, totalRow);
          var totalEl = summary.querySelector('[data-cdc-total]');
          if (totalEl) totalEl.textContent = fmt(offer.price);
        }
        var coupon = this.querySelector('[data-cdc-coupon]');
        if (coupon) coupon.hidden = true;
      }

      hydrateCoupon() {
        var wrap = this.querySelector('[data-cdc-coupon]');
        if (!wrap) return;
        var code = storageGet(COUPON_KEY);
        var applied = wrap.querySelector('[data-cdc-coupon-applied]');
        var toggle = wrap.querySelector('[data-cdc-coupon-toggle]');
        var form = wrap.querySelector('[data-cdc-coupon-form]');
        if (code) {
          wrap.querySelector('[data-cdc-coupon-code]').textContent = code;
          applied.hidden = false;
          toggle.hidden = true;
          form.hidden = true;
        } else {
          applied.hidden = true;
          toggle.hidden = false;
        }
      }

      loadRecs() {
        var section = this.querySelector('[data-cdc-cross][data-url]');
        if (!section) return;
        var self = this;
        var list = section.querySelector('[data-cdc-recs-cards]');
        var key = section.getAttribute('data-url') + '|' + this.getAttribute('data-cart-key');

        function fill(html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelector('[data-cdc-recs-cards]');
          return cards && cards.querySelector('[data-cdc-rec]') ? cards.innerHTML : '';
        }

        function show(inner) {
          if (!inner) {
            section.hidden = true;
            return;
          }
          list.innerHTML = inner;
          section.hidden = false;
        }

        if (this.recsCache[key] !== undefined) {
          show(this.recsCache[key]);
          return;
        }

        origFetch(section.getAttribute('data-url'))
          .then(function (res) { return res.text(); })
          .then(function (html) {
            var inner = fill(html);
            if (inner) return inner;
            return origFetch(section.getAttribute('data-fallback-url'))
              .then(function (res) { return res.text(); })
              .then(fill);
          })
          .then(function (inner) {
            self.recsCache[key] = inner;
            if (self.contains(section)) show(inner);
          })
          .catch(function () {});
      }
    }

    if (!customElements.get('cart-drawer-custom')) {
      customElements.define('cart-drawer-custom', CartDrawerCustom);
    }

    /* ---------- Intercepciones globales (una sola vez) ---------- */
    var PLAIN_FORM_SKIP = 'form[data-tw-buy-form], form[id^="lm-buy-form"], form[data-cdc-skip]';

    function externalChange(url) {
      if (!instance) return;
      var added = /\/cart\/add/.test(url);
      clearTimeout(externalChange.__t);
      externalChange.__t = setTimeout(function () {
        instance.refresh().then(function () {
          if (added) instance.open();
        });
      }, 40);
    }

    function bindGlobals() {
      if (globalsBound) return;
      globalsBound = true;

      /* Ícono del carrito del header */
      document.addEventListener('click', function (e) {
        if (!instance || !e.target || !e.target.closest) return;
        var icon = e.target.closest('#cart-icon-bubble');
        if (!icon) return;
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        instance.open(icon);
      }, true);

      /* Formularios "Agregar al carrito" del tema */
      document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!instance || !form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
        if (form.__cdcBypass || form.matches(PLAIN_FORM_SKIP)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        instance.addFromForm(form, e.submitter || null);
      }, true);

      /* Cambios del carrito hechos por otras secciones/apps (fetch) */
      if (origFetch) {
        window.fetch = function (input, init) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var promise = origFetch(input, init);
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            promise.then(function (res) {
              if (res && res.ok) externalChange(url);
            }).catch(function () {});
          }
          return promise;
        };
      }

      document.addEventListener('cart:refresh', function () { if (instance) instance.refresh(); });
      document.addEventListener('cart:updated', function () { if (instance) instance.refresh(); });
      document.addEventListener('tw:added-to-cart', function () { if (instance) instance.refresh(); });

      /* Editor de temas: abrir al seleccionar la sección */
      document.addEventListener('shopify:section:select', function (e) {
        if (instance && instance.contains(e.target) || (e.target && e.target.querySelector && e.target.querySelector('cart-drawer-custom'))) {
          if (instance) instance.open();
        }
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (instance && e.target && e.target.querySelector && e.target.querySelector('cart-drawer-custom')) instance.close();
      });
    }

    window.NoctapeCartDrawer = {
      open: function () { if (instance) instance.open(); },
      close: function () { if (instance) instance.close(); },
      refresh: function () { return instance ? instance.refresh() : Promise.resolve(); },
      isActive: function () { return !!instance; }
    };
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["doctor-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  function typeInto(root) {
    var paragraph = root.querySelector('[data-typewriter]');
    if (!paragraph) {
      return;
    }

    var output = paragraph.querySelector('[data-typewriter-output]');
    var cursor = paragraph.querySelector('[data-typewriter-cursor]');
    var text = paragraph.getAttribute('data-text') || '';
    var speed = parseInt(root.getAttribute('data-typing-speed'), 10) || 35;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      output.textContent = text;
      if (cursor) {
        cursor.classList.add('is-done');
      }
      return;
    }

    var index = 0;
    function step() {
      if (index <= text.length) {
        output.textContent = text.slice(0, index);
        index++;
        window.setTimeout(step, speed);
      } else if (cursor) {
        cursor.classList.add('is-done');
      }
    }
    step();
  }

  function initDoctorQuote(root) {
    if (root.dataset.typewriterStarted === 'true') {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      root.dataset.typewriterStarted = 'true';
      typeInto(root);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && root.dataset.typewriterStarted !== 'true') {
            root.dataset.typewriterStarted = 'true';
            typeInto(root);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.3 }
    );

    observer.observe(root);
  }

  document.querySelectorAll('.doctor-quote').forEach(initDoctorQuote);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileMq = window.matchMedia ? window.matchMedia('(max-width: 989.98px)') : null;
    var ytPromise = null;

    function loadYouTubeApi() {
      if (ytPromise) return ytPromise;
      ytPromise = new Promise(function (resolve, reject) {
        if (window.YT && window.YT.Player) return resolve(window.YT);
        var previous = window.onYouTubeIframeAPIReady;
        window.onYouTubeIframeAPIReady = function () {
          if (typeof previous === 'function') previous();
          resolve(window.YT);
        };
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/iframe_api';
        tag.onerror = reject;
        document.head.appendChild(tag);
      });
      return ytPromise;
    }

    function parseSource(src, type) {
      if (!src) return null;
      var m;
      if (/^https?:\/\//i.test(src)) {
        m = src.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
        if (m) return { kind: 'youtube', id: m[1] };
        m = src.match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([A-Za-z0-9]+))?/);
        if (m) return { kind: 'vimeo', id: m[1], hash: m[2] || '' };
        return { kind: 'file', url: src, type: type || 'video/mp4' };
      }
      return { kind: 'file', url: src, type: type || 'video/mp4' };
    }

    function init(root) {
      if (root.__htuReady) return;
      root.__htuReady = true;

      var box = root.querySelector('[data-htu-video]');
      var playBtn = root.querySelector('[data-htu-play]');
      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-htu-step]'));
      var source = parseSource(root.getAttribute('data-video-src'), root.getAttribute('data-video-type'));
      var player = null;        // { seek(s), time() } cuando el reproductor está listo
      var loading = null;
      var activeIndex = -1;

      var timed = steps
        .map(function (el, i) {
          var s = el.getAttribute('data-start');
          return s === null || s === '' || isNaN(parseFloat(s)) ? null : { el: el, index: i, start: parseFloat(s) };
        })
        .filter(Boolean)
        .sort(function (a, b) { return a.start - b.start; });

      function setActive(index) {
        if (index === activeIndex) return;
        activeIndex = index;
        steps.forEach(function (el, i) {
          var on = i === index;
          el.classList.toggle('is-active', on);
          var btn = el.querySelector('[data-htu-step-btn]');
          if (btn) btn.setAttribute('aria-current', on ? 'step' : 'false');
        });
      }

      function onTime(t) {
        var current = -1;
        timed.forEach(function (item) { if (t + 0.25 >= item.start) current = item.index; });
        if (current !== -1) setActive(current);
      }

      /* ---------- Reproductores ---------- */
      function mountFile(startAt) {
        var video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.preload = 'auto';
        video.src = source.url;
        video.addEventListener('loadedmetadata', function () {
          if (startAt > 0) video.currentTime = startAt;
        });
        video.addEventListener('timeupdate', function () { onTime(video.currentTime); });
        box.appendChild(video);
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        return Promise.resolve({
          seek: function (s) {
            video.currentTime = s;
            var q = video.play();
            if (q && q.catch) q.catch(function () {});
          }
        });
      }

      function mountYouTube(startAt) {
        return loadYouTubeApi().then(function (YT) {
          return new Promise(function (resolve) {
            var holder = document.createElement('div');
            holder.className = 'htu__yt';
            box.appendChild(holder);
            var timer = null;
            var yt = new YT.Player(holder, {
              videoId: source.id,
              width: '100%',
              height: '100%',
              playerVars: { autoplay: 1, playsinline: 1, rel: 0, modestbranding: 1, start: Math.floor(startAt || 0), origin: window.location.origin },
              events: {
                onReady: function (e) {
                  e.target.playVideo();
                  resolve({
                    seek: function (s) {
                      yt.seekTo(s, true);
                      yt.playVideo();
                    }
                  });
                },
                onStateChange: function (e) {
                  clearInterval(timer);
                  if (e.data === 1) {
                    timer = setInterval(function () { onTime(yt.getCurrentTime()); }, 300);
                  }
                }
              }
            });
          });
        });
      }

      function mountVimeo(startAt) {
        return new Promise(function (resolve) {
          var iframe = document.createElement('iframe');
          var qs = 'autoplay=1&playsinline=1&title=0&byline=0&portrait=0' + (source.hash ? '&h=' + source.hash : '');
          iframe.src = 'https://player.vimeo.com/video/' + source.id + '?' + qs + (startAt > 0 ? '#t=' + Math.floor(startAt) + 's' : '');
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          iframe.title = 'Video tutorial';
          function post(msg) {
            if (iframe.contentWindow) iframe.contentWindow.postMessage(JSON.stringify(msg), 'https://player.vimeo.com');
          }
          window.addEventListener('message', function (e) {
            if (e.origin !== 'https://player.vimeo.com' || e.source !== iframe.contentWindow) return;
            var data = e.data;
            if (typeof data === 'string') { try { data = JSON.parse(data); } catch (err) { return; } }
            if (!data) return;
            if (data.event === 'ready') {
              post({ method: 'addEventListener', value: 'timeupdate' });
            } else if (data.event === 'timeupdate' && data.data) {
              onTime(data.data.seconds);
            }
          });
          iframe.addEventListener('load', function () {
            post({ method: 'addEventListener', value: 'timeupdate' });
            resolve({
              seek: function (s) {
                post({ method: 'setCurrentTime', value: s });
                post({ method: 'play' });
              }
            });
          });
          box.appendChild(iframe);
        });
      }

      function ensurePlayer(startAt) {
        if (player) return Promise.resolve(player);
        if (loading) return loading;
        if (!source || !box) return Promise.reject();
        box.classList.add('is-loaded');
        var mount = source.kind === 'youtube' ? mountYouTube : source.kind === 'vimeo' ? mountVimeo : mountFile;
        loading = mount(startAt).then(function (p) {
          player = p;
          return p;
        });
        return loading;
      }

      /* ---------- Eventos ---------- */
      if (playBtn) {
        playBtn.addEventListener('click', function () { ensurePlayer(0).catch(function () {}); });
      }

      function scrollToVideo() {
        if (mobileMq && mobileMq.matches && box) {
          box.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        }
      }

      steps.forEach(function (el, i) {
        var btn = el.querySelector('[data-htu-step-btn]');
        if (!btn) return;
        var start = parseFloat(el.getAttribute('data-start'));
        if (!source || isNaN(start)) {
          btn.disabled = true;
          btn.setAttribute('aria-disabled', 'true');
          return;
        }
        btn.addEventListener('click', function () {
          setActive(i);
          scrollToVideo();
          if (player) {
            player.seek(start);
          } else {
            ensurePlayer(start).catch(function () {
              btn.disabled = true;
            });
          }
        });
      });

      /* Entrada suave */
      var reveals = root.querySelectorAll('[data-htu-reveal]');
      if (reduceMotion || !('IntersectionObserver' in window)) {
        reveals.forEach(function (n) { n.classList.add('is-in'); });
      } else {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                io.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
        );
        reveals.forEach(function (n) { io.observe(n); });
      }
    }

    function initAll() {
      document.querySelectorAll('[data-htu]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-htu]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["percentage-stats"] && !Shopify.designMode) return;
  try {
    
class XPercentageStats extends HTMLElement {
  constructor() {
    super();
    this.animated = false;
    this.circumference = 339.292;
  }

  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.percentage-stats__item'));
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.3,
    });
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !this.animated) {
        this.animated = true;
        this.animateItems();
        this.observer.disconnect();
      }
    });
  }

  animateItems() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.items.forEach((item) => {
      const target = parseFloat(item.dataset.percentage) || 0;
      const circle = item.querySelector('.percentage-stats__ring-progress');
      const numberEl = item.querySelector('.percentage-stats__ring-number');
      const finalOffset = this.circumference - (this.circumference * target) / 100;

      if (reduceMotion) {
        circle.style.strokeDashoffset = finalOffset;
        numberEl.textContent = target + '%';
        return;
      }

      const duration = 1400;
      let start = null;

      const step = (timestamp) => {
        if (start === null) start = timestamp;
        const progress = Math.min((timestamp - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.round(target * eased);

        numberEl.textContent = current + '%';
        circle.style.strokeDashoffset = this.circumference - (this.circumference * target * eased) / 100;

        if (progress < 1) {
          requestAnimationFrame(step);
        }
      };

      requestAnimationFrame(step);
    });
  }
}

if (!customElements.get('x-percentage-stats')) {
  customElements.define('x-percentage-stats', XPercentageStats);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plan-selector"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPlanSelector(root) {
    var inputs = root.querySelectorAll('.plan-option__input');
    var rewards = root.querySelectorAll('.plan-reward');
    var sellingPlanInput = root.querySelector('[data-plan-selling-plan]');
    var submitBtn = root.querySelector('[data-plan-submit]');
    var submitText = root.querySelector('[data-plan-submit-text]');
    var status = root.querySelector('[data-plan-status]');
    var form = root.querySelector('[data-plan-form]');
    var baseButtonText = submitText ? submitText.textContent : '';
    var showPrice = root.getAttribute('data-show-price') === 'true';
    var behavior = root.getAttribute('data-behavior') || 'redirect';
    var cartAddUrl = root.getAttribute('data-cart-add-url');
    var cartUrl = root.getAttribute('data-cart-url');

    function applySelection(input) {
      inputs.forEach(function (item) {
        var card = item.closest('.plan-option');
        if (card) {
          card.classList.toggle('is-selected', item === input);
        }
      });

      var unlocks = parseInt(input.getAttribute('data-unlocks'), 10) || 0;
      rewards.forEach(function (reward) {
        var index = parseInt(reward.getAttribute('data-index'), 10);
        reward.classList.toggle('is-unlocked', index < unlocks);
      });

      var plan = input.getAttribute('data-selling-plan');
      if (sellingPlanInput) {
        if (plan) {
          sellingPlanInput.value = plan;
          sellingPlanInput.disabled = false;
        } else {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
        }
      }

      if (showPrice && submitText) {
        var price = input.getAttribute('data-price');
        submitText.textContent = price ? baseButtonText + ' - ' + price : baseButtonText;
      }
    }

    inputs.forEach(function (input) {
      input.addEventListener('change', function () {
        applySelection(input);
      });
    });

    var checked = root.querySelector('.plan-option__input:checked') || inputs[0];
    if (checked) {
      checked.checked = true;
      applySelection(checked);
    }

    if (form) {
      form.addEventListener('submit', function (event) {
        if (!cartAddUrl) {
          return;
        }
        event.preventDefault();
        if (submitBtn) {
          submitBtn.disabled = true;
        }
        var formData = new FormData(form);
        fetch(cartAddUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData
        })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('cart_add_failed');
            }
            return response.json();
          })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:updated'));
            if (behavior === 'redirect' && cartUrl) {
              window.location.href = cartUrl;
              return;
            }
            if (status) {
              status.hidden = false;
              status.textContent = 'Se agregó al carrito';
            }
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
            }
          });
      });
    }
  }

  document.querySelectorAll('.plan-selector').forEach(initPlanSelector);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo2-popup"] && !Shopify.designMode) return;
  try {
    
class XPromoPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.promo-popup__dialog');
    this.closeButton = this.querySelector('.promo-popup__close');
    this.dismissButton = this.querySelector('.promo-popup__dismiss');
    this.storageKey = this.dataset.storageKey;
    this.reappearDays = parseFloat(this.dataset.reappearDays) || 0;
    this.delay = parseFloat(this.dataset.delay) || 0;

    if (this.shouldShow()) {
      this.timeoutId = window.setTimeout(() => this.open(), this.delay);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    if (this.dismissButton) {
      this.dismissButton.addEventListener('click', () => this.close());
    }

    this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event));
    this.dialog.addEventListener('close', () => this.remember());
  }

  disconnectedCallback() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId);
  }

  shouldShow() {
    if (this.reappearDays <= 0) {
      return !window.sessionStorage.getItem(this.storageKey);
    }

    const storedAt = window.localStorage.getItem(this.storageKey);
    if (!storedAt) return true;

    const elapsedDays = (Date.now() - parseInt(storedAt, 10)) / 86400000;
    return elapsedDays >= this.reappearDays;
  }

  remember() {
    if (this.reappearDays <= 0) {
      window.sessionStorage.setItem(this.storageKey, '1');
    } else {
      window.localStorage.setItem(this.storageKey, Date.now().toString());
    }
  }

  open() {
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.remember();
    }
  }

  handleBackdropClick(event) {
    const rect = this.dialog.getBoundingClientRect();
    const isInsideDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!isInsideDialog) {
      this.close();
    }
  }
}

if (!customElements.get('x-promo-popup')) {
  customElements.define('x-promo-popup', XPromoPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo3-popup"] && !Shopify.designMode) return;
  try {
    
class XPromoPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('.promo-popup__dialog');
    this.closeButton = this.querySelector('.promo-popup__close');
    this.dismissButton = this.querySelector('.promo-popup__dismiss');
    this.categoryLinks = Array.from(this.querySelectorAll('.promo-popup__category'));
    this.emailForm = this.querySelector('.promo-popup__form');
    this.copyButton = this.querySelector('.promo-popup__copy');
    this.continueButton = this.querySelector('.promo-popup__continue');
    this.codeEl = this.querySelector('.promo-popup__code');
    this.panels = Array.from(this.querySelectorAll('.promo-popup__panel'));
    this.storageKey = this.dataset.storageKey;
    this.reappearDays = parseFloat(this.dataset.reappearDays) || 0;
    this.delay = parseFloat(this.dataset.delay) || 0;
    this.selectedLink = '#';

    if (this.shouldShow()) {
      this.timeoutId = window.setTimeout(() => this.open(), this.delay);
    }

    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    if (this.dismissButton) {
      this.dismissButton.addEventListener('click', () => this.close());
    }

    this.categoryLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.selectedLink = link.getAttribute('href') || '#';
        this.showPanel('email');
        const input = this.emailForm ? this.emailForm.querySelector('input[type="email"]') : null;
        if (input) input.focus();
      });
    });

    if (this.emailForm) {
      this.emailForm.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!this.emailForm.reportValidity()) return;

        const formData = new FormData(this.emailForm);
        fetch(this.emailForm.action, { method: 'POST', body: formData }).catch(() => {});

        if (this.continueButton) this.continueButton.setAttribute('href', this.selectedLink);
        this.showPanel('code');
      });
    }

    if (this.copyButton) {
      this.copyButton.addEventListener('click', () => this.copyCode());
    }

    if (this.continueButton) {
      this.continueButton.addEventListener('click', () => this.remember());
    }

    this.dialog.addEventListener('click', (event) => this.handleBackdropClick(event));
    this.dialog.addEventListener('close', () => this.remember());
  }

  disconnectedCallback() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId);
  }

  showPanel(name) {
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.panel !== name;
    });
  }

  copyCode() {
    if (!this.codeEl) return;
    const code = this.codeEl.textContent.trim();
    const originalLabel = this.copyButton.dataset.copyLabel;
    const copiedLabel = this.copyButton.dataset.copiedLabel;

    if (!navigator.clipboard) return;

    navigator.clipboard.writeText(code).then(() => {
      this.copyButton.textContent = copiedLabel;
      window.setTimeout(() => {
        this.copyButton.textContent = originalLabel;
      }, 2000);
    });
  }

  shouldShow() {
    if (this.reappearDays <= 0) {
      return !window.sessionStorage.getItem(this.storageKey);
    }

    const storedAt = window.localStorage.getItem(this.storageKey);
    if (!storedAt) return true;

    const elapsedDays = (Date.now() - parseInt(storedAt, 10)) / 86400000;
    return elapsedDays >= this.reappearDays;
  }

  remember() {
    if (this.reappearDays <= 0) {
      window.sessionStorage.setItem(this.storageKey, '1');
    } else {
      window.localStorage.setItem(this.storageKey, Date.now().toString());
    }
  }

  open() {
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.remember();
    }
  }

  handleBackdropClick(event) {
    const rect = this.dialog.getBoundingClientRect();
    const isInsideDialog =
      event.clientX >= rect.left &&
      event.clientX <= rect.right &&
      event.clientY >= rect.top &&
      event.clientY <= rect.bottom;

    if (!isInsideDialog) {
      this.close();
    }
  }
}

if (!customElements.get('x-promo-popup')) {
  customElements.define('x-promo-popup', XPromoPopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-carousel"] && !Shopify.designMode) return;
  try {
    
class XSocialCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.social-carousel__track');
    this.prevButton = this.querySelector('.social-carousel__nav--prev');
    this.nextButton = this.querySelector('.social-carousel__nav--next');

    if (!this.track) return;

    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.scrollByDirection(-1));
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.scrollByDirection(1));
    }

    this.track.addEventListener('scroll', () => this.updateButtons());
    this.updateButtons();
  }

  scrollByDirection(direction) {
    this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
  }

  updateButtons() {
    const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth;

    if (this.prevButton) {
      this.prevButton.disabled = this.track.scrollLeft <= 4;
    }

    if (this.nextButton) {
      this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft - 4;
    }
  }
}

if (!customElements.get('x-social-carousel')) {
  customElements.define('x-social-carousel', XSocialCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initVideo(root) {
      var video = root.querySelector('[data-vt-video]');
      if (!video) return;
      var loaded = false;

      function load() {
        if (loaded) return;
        loaded = true;
        video.querySelectorAll('source[data-src]').forEach(function (s) {
          s.src = s.getAttribute('data-src');
        });
        video.muted = true;
        video.load();
      }

      function play() {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      if (!('IntersectionObserver' in window)) {
        load();
        play();
        return;
      }

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              load();
              if (!reduceMotion) play();
            } else if (loaded) {
              video.pause();
            }
          });
        },
        { rootMargin: '200px', threshold: 0.2 }
      ).observe(video);
    }

    function currentVariantId(btn) {
      var field = document.querySelector('form[action*="/cart/add"] [name="id"]');
      return (field && field.value) || btn.getAttribute('data-variant-id');
    }

    function initCta(root) {
      var btn = root.querySelector('[data-vt-cta]');
      if (!btn) return;
      var status = root.querySelector('[data-vt-status]');
      var after = root.getAttribute('data-cart-after');
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
      var addUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/add.js';

      function say(msg) {
        if (status) status.textContent = msg || '';
      }

      btn.addEventListener('click', function () {
        var id = currentVariantId(btn);
        if (!id) {
          say('Este botón solo funciona en una página de producto.');
          return;
        }
        btn.disabled = true;
        say('');
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw new Error(data.description || data.message || 'Error');
              return data;
            });
          })
          .then(function () {
            var drawer = document.querySelector('cart-drawer, cart-notification');
            if (after === 'drawer' && drawer && typeof drawer.open === 'function') {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              drawer.open();
              btn.disabled = false;
              say('Producto agregado al carrito.');
            } else {
              window.location.href = cartUrl;
            }
          })
          .catch(function (err) {
            btn.disabled = false;
            say(err && err.message ? err.message : 'No se pudo agregar al carrito.');
          });
      });
    }

    function init(root) {
      if (root.__vtReady) return;
      root.__vtReady = true;
      initVideo(root);
      initCta(root);
    }

    function initAll() {
      document.querySelectorAll('[data-vt]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-vt]') : null;
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-it-works"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initWhyWorks(root) {
    var grid = root.querySelector('[data-why-works-grid]');
    if (!grid) {
      return;
    }

    if (!('IntersectionObserver' in window)) {
      grid.classList.add('is-visible');
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            grid.classList.add('is-visible');
            observer.disconnect();
          }
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(grid);
  }

  document.querySelectorAll('.why-works').forEach(initWhyWorks);
})();

  } catch(e) { console.error(e); }
})();
})();
